import type {
  AddressData,
  ShippingData,
} from 'src/sdk/checkout/data/types/orderformAPI'

import { normalizePostalCode } from '../utils/postalCode'

function compareAddressesForDisplayOrder(params: {
  left: AddressData
  right: AddressData
  defaultAddressId: string | null
  selectedAddressId?: string | null
}): number {
  const { left: a, right: b, defaultAddressId, selectedAddressId } = params

  if (a?.addressId === defaultAddressId) return -1
  if (b?.addressId === defaultAddressId) return 1

  if (a?.addressId === selectedAddressId) return -1
  if (b?.addressId === selectedAddressId) return 1

  return 0
}

export function sortDefaultAddressFirst(
  addresses: AddressData[],
  defaultAddressId: string | null,
  selectedAddressId?: string | null
) {
  const arr = Array.isArray(addresses) ? addresses : []

  return [...arr].sort((a, b) =>
    compareAddressesForDisplayOrder({
      left: a,
      right: b,
      defaultAddressId,
      selectedAddressId,
    })
  )
}

export function resolveSelectedAddressId(
  shippingData?: ShippingData | null,
  currentPostalCode?: string
) {
  const availableAddresses = shippingData?.availableAddresses ?? []
  const selectedFromOrderForm =
    shippingData?.selectedAddresses?.[0]?.addressId ??
    shippingData?.address?.addressId ??
    null

  if (
    selectedFromOrderForm &&
    availableAddresses.some((addr) => addr.addressId === selectedFromOrderForm)
  ) {
    return selectedFromOrderForm
  }

  const normalizedPostalCode = normalizePostalCode(currentPostalCode)

  if (!normalizedPostalCode) {
    return selectedFromOrderForm
  }

  const matchedAddressByPostalCode = availableAddresses.find(
    (addr) => normalizePostalCode(addr?.postalCode) === normalizedPostalCode
  )

  return matchedAddressByPostalCode?.addressId ?? selectedFromOrderForm
}
